import { isPlatformSuperAdmin } from 'pure-js/libs/isSuperUser'
import useAppState from '../../hooks/useAppState'
import useFirebaseUser from '../../hooks/useFirebaseUser'
import { useFeatureFlags } from './useFeatureFlags'

/** Feature flag plus platform-operator rights; false while auth loads so routes never flash open. */
export function useCanAccessGenerateReports() {
  const { isGenerateReportsEnabled } = useFeatureFlags()
  const { isLoading: isAuthLoading } = useFirebaseUser()
  const { state } = useAppState()

  const canAccessGenerateReports = isGenerateReportsEnabled && !isAuthLoading && isPlatformSuperAdmin(state.user)

  return { canAccessGenerateReports, isGenerateReportsEnabled, isAuthLoading }
}
